"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getMiniButtonUtilityClass = getMiniButtonUtilityClass;
var _mui = require("@ori-ui/mui");
function getMiniButtonUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('MiniButton', slot);
}
const miniButtonClasses = (0, _mui.generateUtilityClasses)('MiniButton', ['root', 'text', 'textDefault', 'textError', 'focusVisible', 'disabled']);
var _default = exports.default = miniButtonClasses;
